const key = value => String(value ?? '').trim()
const isPcItem = item => item.showType == null || String(item.showType) === '1'
const isVisible = item => Number(item.status ?? item.enabled ?? 1) === 1
  && Number(item.deleted ?? item.isDelete ?? 0) === 0 && isPcItem(item)

// PC navigation is returned as a flat list. Keep IDs as strings: shop/menu IDs
// exceed Number's safe integer range, and a blank link can be a submenu group.
export function buildAustraliaPcNavigation(rows = []) {
  if (!Array.isArray(rows)) return []
  const records = rows.filter(item => item && typeof item === 'object')
  const byId = new Map(records.filter(item => key(item.id)).map(item => [key(item.id), item]))
  function visible(item, ancestors = new Set()) {
    if (!isVisible(item) || ancestors.has(item)) return false
    const parent = byId.get(key(item.parentId))
    return !parent || visible(parent, new Set([...ancestors, item]))
  }
  const nodes = new Map(records.filter(item => visible(item) && key(item.title || item.name)).map(item => [item, {
    ...item, title: item.title || item.name, childrenList: [],
  }]))
  const roots = []
  for (const [record, node] of nodes) {
    const parent = nodes.get(byId.get(key(record.parentId)))
    // Match the admin tree's handling of older records with missing parents.
    if (parent) parent.childrenList.push(node)
    else roots.push(node)
  }
  function sort(items) {
    items.sort((a, b) => (Number(a.sortNo) || 0) - (Number(b.sortNo) || 0))
    items.forEach(item => sort(item.childrenList))
    return items
  }
  return sort(roots)
}

export function readAustraliaPcNavigation(response) {
  const rows = Array.isArray(response?.data) ? response.data : response?.data?.dataList
  if (response?.success === false || !Array.isArray(rows)) return { configured: false, items: [] }
  const records = rows.filter(item => item && isPcItem(item))
  return {
    configured: true,
    items: buildAustraliaPcNavigation(records),
  }
}

// PC navigation owns the entire header row. The catalog is only a service-error
// fallback; lowcode's old Product List / About / Contact shell is not merged in.
export function resolveAustraliaNavigation(pcNavigation = null, fallback = []) {
  return pcNavigation?.configured ? pcNavigation.items : fallback
}
